import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Spin } from "antd";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  // Allowed public routes
  const allowedPublicRoutes = [
    "/login",
    "/logout",
    "/intuit-launch",
    "/intuit-connect",
    "/intuit-connect-complete",
    "/intuit-disconnect",
    "/intuit-disconnect-complete",
    "/intuit-unverified",
  ];

  // Fix back button showing cached screens after logout
  useEffect(() => {
    window.onpageshow = function (event) {
      if (event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward") {
        window.location.reload();
      }
    };
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  // Allow access to login and logout routes even if not authenticated
  if (!isAuthenticated && !allowedPublicRoutes.includes(location.pathname)) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
